import { render } from "./advertView.vue?vue&type=template&id=6efdd9e2&scoped=true"
import script from "./advertView.vue?vue&type=script&lang=js"
export * from "./advertView.vue?vue&type=script&lang=js"

import "./advertView.vue?vue&type=style&index=0&id=6efdd9e2&scoped=true&lang=css"

import exportComponent from "../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-6efdd9e2"]])

export default __exports__